var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Page from '../Page';
import { ApplicationContext } from '../../../ApplicationContext';
import GetReportDefinitonsCommand from "../../../commands/reports/GetReportDefinitonsCommand";
import Signals from "../../../signals/Signals";
import ReportTableOverlay from "./ReportTableOverlay";
import ReportRow from "./ReportRow";
/**
 *
 */
var Reports = /** @class */ (function (_super) {
    __extends(Reports, _super);
    /**
     *
     */
    function Reports(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.onViewReport = _this.onViewReport.bind(_this);
        return _this;
    }
    /**
     *
     */
    Reports.prototype.componentDidMount = function () {
        this.initialize();
    };
    /**
     *
     */
    Reports.prototype.initialize = function () {
        var _a = this.context, session = _a.session, reportCollection = _a.reportCollection;
        var user = session.user;
        var command = new GetReportDefinitonsCommand();
        command.execute(user.organisation, reportCollection);
    };
    /**
     *
     * @returns {*}
     */
    Reports.prototype.render = function () {
        var intl = this.props.intl;
        var _a = this.context, session = _a.session, reportCollection = _a.reportCollection;
        if (!session.isLoggedIn) {
            return null;
        }
        return (React.createElement(Page, { pageName: "reports" },
            React.createElement("div", { className: "h-100 pb-4" },
                React.createElement("div", { className: "card h-100", style: { width: "95%", borderRadius: "0px 20px 20px 0px" } },
                    React.createElement("div", { className: "card-header align-items-start flex-grow-0 pb-0" },
                        React.createElement("div", { className: "d-flex justify-content-between mb-4 pr-3 flex-wrap" },
                            React.createElement("h1", { className: 'header-title align-self-center order-0 mr-3' },
                                React.createElement(FormattedMessage, { id: "page.reports.title" })))),
                    React.createElement("div", { className: "card-body pt-0 mr-4 pr-0 overflow-auto" },
                        React.createElement("div", { className: "table-container w-100 h-100 flex-fill" },
                            React.createElement("div", { className: "" },
                                React.createElement("div", { className: "w-100", style: {
                                        display: "grid",
                                        gridTemplateColumns: "1fr 4fr 1fr",
                                        rowGap: "1.3rem",
                                        minWidth: "fit-content"
                                    } },
                                    React.createElement("div", { className: 'w-100 position-sticky text-nowrap text-uppercase bg-secondary px-3 pb-2 table-header', style: { display: "contents", top: 0, zIndex: 1 } },
                                        React.createElement("div", null,
                                            React.createElement(FormattedMessage, { id: "page.reports.table.title" })),
                                        React.createElement("div", null,
                                            React.createElement(FormattedMessage, { id: "page.reports.table.description" })),
                                        React.createElement("div", null,
                                            React.createElement(FormattedMessage, { id: "page.reports.table.category" }))),
                                    reportCollection.list.map(function (reportModel, index) {
                                        return React.createElement(ReportRow, { key: 'report-' + reportModel.id, reportModel: reportModel });
                                    })))))))));
    };
    /**
     *
     * @param event
     */
    Reports.prototype.onViewReport = function (event) {
        var reportId = event.currentTarget.dataset.id;
        var _a = this.context, session = _a.session, reportCollection = _a.reportCollection;
        var reportModel = reportCollection.findById(reportId);
        // const command : CreateReportCommand = new CreateReportCommand();
        // command.execute(session.user.organisation.id, reportModel.id, reportModel.parameterInfos.map((model: ReportParameterInfoModel) => {
        //     return model;
        // }));
        Signals.ShowOverlay.dispatch(React.createElement(ReportTableOverlay, { reportModel: reportModel }));
    };
    /**
     *
     * @param error
     */
    Reports.prototype.onError = function (error) {
    };
    Reports = __decorate([
        observer
    ], Reports);
    return Reports;
}(React.Component));
Reports.contextType = ApplicationContext;
export default injectIntl(Reports);
